/**
 * Copyright (C) 2021-2026 Technology Matters
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see https://www.gnu.org/licenses/.
 */

import { BoxStyleProps } from '@twilio-paste/core/box';
import { TextStyleProps } from '@twilio-paste/core/text';

export const formStyles: BoxStyleProps = {
  padding: 'space40',
  paddingTop: 'space80',
  overflow: 'auto',
};

export const titleStyles: TextStyleProps = {
  fontSize: 'fontSize70',
  marginBottom: 'space60',
};

export const descriptionStyles: TextStyleProps = {
  marginBottom: 'space30',
};

// export const introStyles: TextStyleProps = {
//   marginBottom: 'space70',
// };

export const fieldStyles: BoxStyleProps = {
  marginBottom: 'space70',
};
